export default "__VITE_ASSET__e5994143__"